import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Icon,
  UncontrolledTooltip,
} from '@polichat/flamboyant';
import { useContext, useState } from 'react';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { useFlags } from 'flagsmith/react';
import { customUseFlags } from 'src/hooks/customUseFlags';

import { isMobile } from 'react-device-detect';
import checkAvatar from '../../../../utils/checkAvatar';
import Avatar from '../../../common/profile/Avatar';
import ContactName from '../../../common/profile/ContactName';

import FinishChatModal from './modals/FinishChatModal';
import FinishedChatModal from './modals/FinishedChatModal';
import TransferChatModal from './modals/TransferChatModal';

import CartChatModal from './modals/CartChatModal';

import Modals from './modals/Modals';

import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Vox } from 'src/components/common/vox';
import { GlobalContext } from 'src/context/globalContext';
import * as ChatActions from '../../../../store/modules/chat/actions';
import poliConfig from '../../../../utils/poliConfig';
import CustomBox from '../../../common/structure/header/CustomBox';
import { BackToComponent } from '../../../mobile/back-to-actions/BackToComponent.component';
import { SummaryWithDatePicker } from 'src/components/common/Summary';

import { FinishChatModalFlow } from './FinishChat';

function Header({
  blockInteraction,
  chat,
  chatDetails,
  showDetailsComponent,
  openFinishChatModal,
  openTransferChatModal,
  openTagChatModal,
  users,
  openPaymentChatModal,
  openCartChatModal,
  props,

  // mobile action navigation
  showBlockThree,
}) {
  // Context
  const { pictureGlobal } = useContext(GlobalContext);

  function handleDetails(showDetails) {
    if (showDetails === true) {
      showDetails = false;
    } else if (showDetails === undefined || showDetails === false) {
      showDetails = true;
    }
    showDetailsComponent(showDetails);
  }

  const customer_id = useSelector(
    (state) => state.general?.current_customer_id
  );
  const wl = useSelector((state) => state?.whitelabel?.config);

  const isWhiteLabel = useSelector(
    (state) => state?.whitelabel?.config?.is_white_label
  );
  const hideVoxButton = useSelector(
    (state) => state?.whitelabel?.config?.hide_vox_button || false
  );
  const showCustomBoxWL = useSelector((state) => {
    return (
      state?.whitelabel?.config?.script_injection &&
      state?.whitelabel?.config?.script_injection !== ''
    );
  });

  const contact = chat.contact;
  const chat_read = chat.chat_read === 1;
  const [moreActions, setMoreActions] = useState(false);
  const operator = chat?.contact?.operator;
  let operatorData;

  // Responsável por adicionar a imagem do operator atual do chat
  if (operator && operator !== null && users) {
    operatorData = users.find((user) => user.id === operator);

    if (operatorData) {
      if (operatorData.name) {
        operatorData.picture = checkAvatar(
          operatorData.name,
          operatorData.picture
        );
      }
    }
  }
  const isFinishChatModalOpen = chat.finish_chat_modal_open;
  const isTransferChatModalOpen = chat.transfer_chat_modal_open;

  const flag = useFlags(['finish_chat']);
  const finishChatFlag = customUseFlags(flag.finish_chat);

  const isCartChatModalOpen = chat.cart_chat_modal_open;

  const isChatOpen = chat.chat.status;

  const toggle = () => setMoreActions((prevState) => !prevState);

  // Traduções
  const forwardChatText = useGlotaT('spa.chat.actions.forwardChat');
  const addTagText = useGlotaT('spa.chat.actions.addTag');
  const exportConversationText = useGlotaT(
    'spa.chat.actions.exportConversation'
  );
  const addChargeText = useGlotaT('spa.chat.actions.addCharge');
  const addCartText = useGlotaT('spa.chat.actions.addCart');
  const endConversationText = useGlotaT('spa.chat.actions.endConversation');
  const attendantText = useGlotaT('spa.chat.attendant');
  const noAttendantAssignedText = useGlotaT('spa.chat.noAttendantAssigned');

  const renderFinishChatModal = () => {
    if (!isFinishChatModalOpen) return null;

    if (isChatOpen) {
      if (finishChatFlag) return <FinishChatModalFlow />;
      return <FinishChatModal />;
    }

    //caso chat esteja fechado
    return <FinishedChatModal />;
  };

  return (
    <div className="headerChat">
      <TransferChatModal isOpen={isTransferChatModalOpen} />
      {/* todos os modais */}
      <Modals blockInteraction={blockInteraction} />
      {isMobile && <BackToComponent />}

      <div
        className="contactInfo"
        onClick={() => {
          handleDetails(chatDetails);
          // Disparar action para mostrar bloco 3
          isMobile && showBlockThree();
        }}
      >
        <Avatar
          className="contact"
          title={chat.contact.name}
          url={
            !!pictureGlobal
              ? pictureGlobal
              : checkAvatar(chat.contact.name, chat.contact.picture)
          }
          size={36}
        />
        <div className="contactNameContainer">
          <ContactName name={contact.name} read={chat_read} />
        </div>
      </div>
      {showCustomBoxWL ? <CustomBox local="headChat" /> : <></>}
      <div className="headerChatActions">
        {!hideVoxButton && wl.spa_title !== 'NectarCRM' && (
          <Vox
            contact={chat.contact}
            user={users}
            channel={props}
            channels={props}
          />
        )}

        <SummaryWithDatePicker chat={chat} />
        <div style={{ marginLeft: '12px' }}>
          <Button
            id="tooltipOperator"
            color="secondary"
            onClick={() => {
              openTransferChatModal();
            }}
            style={{
              height: '40px',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Avatar
              className="operator"
              title={operatorData ? operatorData.name : '-'}
              url={operatorData ? operatorData.picture : '-'}
              size={36}
              customStyles={{
                backgroundColor: 'var(--primary)',
              }}
            />
          </Button>
        </div>

        <UncontrolledTooltip placement="bottom" target="tooltipOperator">
          {operatorData && operatorData.name
            ? `${attendantText}: ${operatorData.name}`
            : noAttendantAssignedText}
        </UncontrolledTooltip>
        {/* Mais ações */}
        <Dropdown isOpen={moreActions} toggle={toggle}>
          <DropdownToggle color="link">
            <Icon size="20" icon="poli-icon pi-bullet-fill" />
          </DropdownToggle>

          {renderFinishChatModal()}

          {isCartChatModalOpen && <CartChatModal />}

          {!isFinishChatModalOpen && (
            <DropdownMenu
              right
              className="menuDropdownShow header__dropdown-actions"
            >
              <DropdownItem
                className="itemDropdownMenu"
                onClick={() => {
                  openTransferChatModal();
                }}
              >
                <Icon icon={'poli-icon pi-talks-line'} size={20} />
                <p className="alternative">{forwardChatText}</p>
                <Icon
                  icon={'poli-icon poli-icon pi-share-arrow-line'}
                  size={20}
                />
              </DropdownItem>

              {
                /* Sempre deve exibir a opção de etiqueta, mesmo se não houver etiquetas */
                <DropdownItem
                  className="openPaymentForm"
                  onClick={() => {
                    openTagChatModal();
                  }}
                >
                  <Icon icon={'poli-icon pi-tag-line'} size={20} />
                  <p className="alternative">{addTagText}</p>
                  <Icon icon={'poli-icon pi-add-line'} size={20} />
                </DropdownItem>
              }

              <DropdownItem
                className="itemDropdownMenu unavailable-item"
                onClick={() =>
                  (window.location.href = `${poliConfig.poliAppLaravelUrl}/actions/${customer_id}`)
                }
              >
                <Icon icon={'poli-icon pi-download-line'} size={20} />
                <p className="alternative">{exportConversationText}</p>
                <Icon icon={'poli-icon pi-simple-arrow-right-line'} size={20} />
              </DropdownItem>

              {/* Pagamento */}
              {!isWhiteLabel && (
                <DropdownItem
                  className="itemDropdownMenu openPaymentForm"
                  onClick={() => openPaymentChatModal()}
                >
                  <Icon icon={'poli-icon pi-pay-line'} size={20} />
                  <p className="alternative">{addChargeText}</p>
                  <Icon icon={'poli-icon pi-add-line'} size={20} />
                </DropdownItem>
              )}

              {!isWhiteLabel &&
                (chat.cart ? null : (
                  <DropdownItem
                    className="itemDropdownMenu openCartForm"
                    onClick={() => openCartChatModal(chat.id)}
                  >
                    <Icon icon={'poli-icon pi-ecommerce-line'} size={20} />
                    <p className="alternative">{addCartText}</p>
                    <Icon icon={'poli-icon pi-add-line'} size={20} />
                  </DropdownItem>
                ))}

              <DropdownItem
                className="itemDropdownMenu closeChat"
                onClick={() => {
                  openFinishChatModal();
                }}
              >
                <Icon icon={'poli-icon pi-talks-line'} size={20} />
                <p className="alternative">{endConversationText}</p>
                <Icon icon={'poli-icon pi-simple-arrow-right-line'} size={20} />
              </DropdownItem>
            </DropdownMenu>
          )}
        </Dropdown>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  chat: state.chat.chats?.find((chat) => chat.open === true),
  chatDetails: state.chat.showDetails,
  users: state.chat?.config?.general?.users,
  hasTags: state.chat?.config?.general?.tags?.length > 0,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
